import gql from 'graphql-tag';

const defaultCoverageOptOutsQuery = gql`
  query GetDefaultCoverageOptOuts(
    $buyerNumber: String
    $sellerNumber: String
    $auctionAccessNumber: String
    $page: Int
    $size: Int
  ) {
    defaultCoverageOptOuts(
      buyerNumber: $buyerNumber
      sellerNumber: $sellerNumber
      auctionAccessNumber: $auctionAccessNumber
      page: $page
      size: $size
    ) {
      total
      items {
        id
        buyerNumber
        sellerNumber
        auctionAccessNumber
        productId
        productCode
        status
        startDate
        endDate
        notes
        version
        createdBy
        createdAt
        updatedBy
        updatedAt
      }
    }
  }
`;

export default defaultCoverageOptOutsQuery;
